export const EMAIL_FIELD = 'email'
export const PASSWORD_FIELD = 'password'

export const getDefaultValues = () => ({
  [EMAIL_FIELD]: '',
  [PASSWORD_FIELD]: '',
})
